<template>
    <div class="afisha-wrap">

    </div>
</template>
<style lang="stylus" scoped>
    .afisha-wrap {
        margin 0 auto
        max-width 998px
        width 100%
        height 2082px
        background url('./screencapture-afisha-ru.png') no-repeat top center
    }
</style>
<script>
    import mixin from '@/web/mixin.js'
    export default {
        mixins: [mixin],
        mounted () {
            this.event('view', {site: 'afisha.ru'})
        }
    }
</script>